export const INTRO_ROUTE = "/intro";
export const COMPETITIONS_ROUTE = "/konkurranser";
export const CONTESTANTS_ROUTE = "/deltakere";
export const LEADERBOARD_ROUTE = "/sammendrag";
export const TEAM_SHUFFLER_ROUTE = "/lagvelger";
export const SPINNING_WHEEL_ROUTE = "/karusell";
export const TOURNAMENT_ROUTE = "/turnering/:id";
export const TOURNAMENT_DRAWER_ROUTE = "/turneringstrekker";

export const formatTournamentRoute = (tournament: string) =>
  `/turnering/${tournament.replaceAll(" ", "-")}`;
